import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/layout.css";
import "../css/login.css";
import findGif from "../css/loading_old.gif";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from "../store/allApi";

export default function Login() {
  const history = useHistory();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [time, setTime] = useState(new Date());
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const [receivedOTP, setReceivedOTP] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if ("OTPCredential" in window) {
        const ac = new AbortController();

        try {
          const otpCredential = await navigator.credenstials?.get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          });
          setReceivedOTP(otpCredential?.code);
          ac.abort();
        } catch (err) {
          ac.abort();
          console.log(err);
        }
      }
    };

    fetchData();
  }, []);

  const handleClick = async (e) => {

    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);
      let newTime = Date()

      try {
        const respone = await apiRequest(`login`, "POST", { Phone, referral, newTime }, null)
        if (respone) {
          setIsloading1(false);
          if (respone.data.status == 101) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: respone.data.msg,
            });
          } else if (respone.data.status == 200) {
            setOtp(true);
            setSecretCode(respone.data.secret);
            if (respone.data.myToken) {
              Swal.fire({
                icon: "success",
                title: "OTP",
                text: "Demo Account Testing OTP: " + respone.data.myToken,
              });
            }
          }
          else if (respone?.data?.status == false) {
            Swal.fire({
              icon: "error",
              text: respone?.data?.msg,
            });
          }
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });

      }
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();

    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }

    setIsloading1(true);

    // try {
    //   const response = await axios.post(baseUrl + "login/finish", {
    //     Phone,
    //     twofactor_code,
    //     referral,
    //     secretCode,
    //   });


    //   setIsloading1(false);

    //   if (response.data.status === 101) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: response.data.msg,
    //     });
    //   } else if (response.data.status === 200) {
    //     const token = response.data.token;
    //     localStorage.setItem("token", token);
    //     // Reload the page and redirect after a delay
    //     setTimeout(() => {
    //       window.location.reload(true);
    //       history.push("/Games"); // Assuming you have 'history' available
    //     }, 1000);
    //   } else {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: "Something went wrong!",
    //     });
    //   }
    // } catch (error) {
    //   setIsloading1(false);
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "Something went wrong!",
    //   });
    // }


    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode }, null)
      setIsloading1(false);

      if (response.data.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.msg,
        });
      } else if (response.data.status === 200) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  // otp valid
  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true); // Show the Resend button when OTP expires
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false); // Hide the Resend button after clicking it
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" }}>
        <div className="login_main-area ">

          <div className="login_v2_wrapper">

  <div className="login_v2_card">

    <div className="login_top_section">

      <div className="logo_circle">
        <img
          src="/logo.png"
          alt="logo"
          className="login_logo_v2"
        />
      </div>

      <h2>Welcome Back 👋</h2>

      <p>
        Login with your mobile number to continue
      </p>

    </div>

    {/* Mobile Input */}

    <div className="input_group_v2">

      <label>Mobile Number</label>

      <div className="phone_input_v2">

        <div className="country_code">
          🇮🇳 +91
        </div>

        <input
          type="tel"
          placeholder="Enter mobile number"
          onChange={(e) => {
            setPhone(e.target.value);
          }}
        />

      </div>

    </div>

    {otp && (
      <>
        <div className="input_group_v2 mt-3">

          <label>Verification Code</label>

          <div className="otp_input_v2">

            <input
              type="tel"
              placeholder="Enter OTP"
              onChange={(e) =>
                settwofactor_code(e.target.value)
              }
            />

          </div>

        </div>

        <div className="otp_status_box">

          {seconds > 0 ? (
            <span>
              OTP expires in {seconds}s
            </span>
          ) : (
            showResend && (
              <button
                className="resend_btn_v2"
                onClick={handleResendClick}
              >
                Resend OTP
              </button>
            )
          )}

        </div>
      </>
    )}

    {!otp ? (
      <button
        className="login_cta_btn"
        onClick={(e) => {
          handleClick(e);
          setIsValid(true);
        }}
      >
        {isLoading1 ? (
          <>
            <Spinner
              animation="grow"
              size="sm"
            />
            Sending...
          </>
        ) : (
          <>
            Get OTP →
          </>
        )}
      </button>
    ) : (
      <button
        className="login_cta_btn"
        onClick={(e) => varifyOtp(e)}
      >
        {isLoading1 ? (
          <>
            <Spinner
              animation="grow"
              size="sm"
            />
            Verifying...
          </>
        ) : (
          <>
            Verify & Login →
          </>
        )}
      </button>
    )}

  </div>

</div>
          {/* <div className="login-footer mb-5">
            By continuing I agree that Team may
            store and process my data in accordance with the{" "}
            <Link to="/about">About</Link> <Link to="/contact-us">Contact</Link>{" "}
            <Link to="/Terms">Privacy-Policy</Link>  <Link to="/shipping-delivery-policy">Shipping-Delivery-Policy</Link> <Link to="/RefundPolicy">Refund-Policy</Link> <Link to="/term-condition">Term-Condition</Link> and that I am 18 years or
            older. I am not playing from Assam, Odisha, Nagaland, Sikkim,
            Meghalaya, Andhra Pradesh, or Telangana.
          </div> */}
        </div>
      </div>
    </>
  );
}
